import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import { UPDATE_MEMBER_LEVEL } from "../../../../graphql/mutations/management";
import { GET_MEMBER_LIST } from "../../../../graphql/queries/management";

import CustomSelect from "../../../../components/form/CustomSelect";
import {
  clearFormMemberLevel,
  onChangeMemberLevel,
} from "../../../management/redux/managementSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const UpdateMemberLevelForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { updateFormMemberLevel } = management;

  const [updateMemberLevel, { loading: loadingCreate }] = useMutation(
    UPDATE_MEMBER_LEVEL,
    {
      variables: {
        member: updateFormMemberLevel.member,
        level: updateFormMemberLevel.level,
      },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
          dispatch(clearFormMemberLevel());
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    updateMemberLevel();
  };

  const handleChange = (e) => dispatch(onChangeMemberLevel(e.value));

  const levels = [
    { id: 1, level: "Gold" },
    { id: 2, level: "VIP" },
  ];

  const options = levels?.map((l) => ({
    value: l.id,
    label: l.level,
  }));

  const renderLevel = (level) => {
    switch (level) {
      case 1:
        return <span>Gold</span>;
      case 2:
        return <span>VIP</span>;
      default:
        break;
    }
  };

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomSelect
        handleChange={handleChange}
        placeholder={renderLevel(updateFormMemberLevel?.level)}
        options={options}
      />

      <div className="text-center m-2">
        <SubmitButton loading={loadingCreate} />
      </div>
    </Form>
  );
};

export default UpdateMemberLevelForm;
